module.exports = __webpack_public_path__ + "img/online_img.201b91d9.png";